import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { Grid, Slider, Box, Button, DialogActions, DialogTitle, DialogContent, Dialog, Menu, MenuItem } from '@material-ui/core';
import Typo from '../../components/CustomTypo';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { getAppCfg } from '../../utils/common';
import ProgressBar from '../../components/ProgressBar';
import defaultTheme, { commonColor } from '../../theme.css';
import { GiftIcon, StarIcon, ReNewIcon, DateRangeBlackIcon } from '../../components/icons';
import ButtonCustom from '../../components/ButtonCustom';
import { formatDateToDDMMYYYYFrEpoch } from '../../utils/util';
import { custom_assets, domainName, portal_config } from '../../../portal.config';
import { portalCfg } from '../../../portal.router.config';
import crmservices from '../../wsclient/crmservices';

var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";


const heightCoverItem = 180
const heightContentItem = 140

const styles = theme => ({
    container: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },
    sub_img: {
        display: 'flex',
        alignItems: 'center'
    },
    item_cover: {
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: theme.spacing(1),
        "& img": {
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5),
        }
    },
    status: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    sub_date: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // height: 100
    }
});
function SubcriptionItem(props) {
    const { classes, t, item, currency, from, productsOTT } = props;
    const [listProductCatalogue, setListProductCatalogue] = useState([])
    const [anchorEl, setAnchorEl] = useState(null);
    // console.log("AAA item sub===", item);
    let images = dataUtil.getImageByUsageType(item.service && item.service.product ? item.service.product.creatives : null, usage_type.product_item);
    // console.log("AAA image sub===", images);
    let imageSub = path + '/images/logo.png';
    if (images && images.length > 0) {
        imageSub = images[0].uri;
    }
    let isFreeTV = item?.service?.product?.sku?.toUpperCase() == portal_config.add_on_free ? true : false;
    let showUpgradeButton = false;
    if (item.service && item.service.life_cycle_state != 'DRAFT' && !isFreeTV) {
        showUpgradeButton = true;
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    useEffect(() => {
        getListProductOrderCatalogue()
    }, [])

    const getListProductOrderCatalogue = async () => {
        let appConfig = getAppCfg()
        let orderCatalogId = appConfig?.features?.ordering_details?.order_catalogs?.find((item) => item.name && item.name.toLowerCase() == portal_config.order_catalog)?.id;
        console.log("AAAA orderCatalogId", orderCatalogId)
        if (!orderCatalogId) {
            return
        }
        try {
            let result = await crmservices.products.getProductsCatalogue({ order_catalog_id: orderCatalogId })
            if (result.code == "OK" && result?.data?.content?.length > 0) {
                setListProductCatalogue(result?.data?.content)
            }
        } catch (error) {
            console.log("Error")
        }
    }
    const appConfig = getAppCfg();
    const isCrocOTTCatalogs = productsOTT?.find(x => x.id == item?.service?.product?.id) ? true : false;
    const showViewDevicesButton = !isFreeTV && isCrocOTTCatalogs ? true : false;
    const showCancelServiceButton = from == 'subscription_page' && (!item?.service?.removed_on && listProductCatalogue.some((ix) => ix.id == item?.service?.product?.id)) ? true : false;
    console.log("AAAA showViewDevicesButton: ", showViewDevicesButton)
    console.log("AAAA productsOTT: ", productsOTT)
    return (
        <Grid xs={12} sm={6} md={6} lg={5} xl={4} item container className={classes.container}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container style={{ alignItems: "center" }}>
                    <Grid item xs={12} md={9}>
                        <Grid item xs={12} className={classes.sub_img}>
                            <Grid item className={classes.item_cover}>
                                <img src={imageSub} alt="Image Service" />
                            </Grid>
                            <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{item.service && item.service.product ? item.service.product.name : ""}</Typo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ textAlign: 'right' }}>
                        <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{currency}{item.service && item.service.price ? item.service.price.price.toFixed(2) : "0.00"}</Typo>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.status}>
                    <ButtonCustom size="xs" color={"success"}>{item.service && item.service.life_cycle_state ? item.service.life_cycle_state : ''}</ButtonCustom>
                    {item.service && item.service.terms && item.service.terms.in_contract &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_contract')}</ButtonCustom>}

                    {item.service && item.service.trial_period && item.service.trial_period.trial_state == "IN_TRIAL" &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_trial')}</ButtonCustom>}
                    {domainName == 'airlink' && item.service && item.service.is_recurring_charge && from == 'subscription_page' && <ButtonCustom size="xs" color={"primary"}>{t('recurring_charge')}</ButtonCustom>}

                    {/* {showUpgradeButton && <ButtonCustom size="xs" color={"primary"} onClick={() => props.onUpgradeService(item.service)}>Change Service</ButtonCustom>} */}
                    {item?.service?.removed_on && <ButtonCustom size="xs" color={"warning"}>Pending Changes</ButtonCustom>}
                </Grid>
                <Grid item container className={classes.sub_date}>
                    {item.service && item.service.terms && item.service.terms.auto_renew && item.service.life_cycle_state != 'DRAFT' &&
                        <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                            <ReNewIcon />
                            <Grid item style={{ paddingLeft: 10 }}>
                                <Typo variant='subtitle2'>{t('auto_renew')}</Typo>
                                <Typo variant='body2'>{item.service.terms.termed_period && item.service.terms.termed_period.end_date ? formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.end_date) : ''}</Typo>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.terms.in_contract
                        && item.service.terms.contract_period
                        && item.service.terms.contract_period.start_date
                        && item.service.terms.contract_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'> {t('sub_contract_period') + " "} </Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.trial_period
                        && item.service.trial_period.end_date
                        && item.service.trial_period.start_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'>{t('sub_trial_period')}</Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.trial_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.trial_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.terms.termed_period
                        && item.service.terms.termed_period.start_date
                        && item.service.terms.termed_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'> {t('latest_billed_period') + " "} </Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                {domainName == 'airlink' && <Grid item xs={12} style={{ position: "relative" }} container justifyContent='center' alignItems='center'>
                    <Grid item xs={12} lg={7} container>
                        {item.service && item.service.added_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{item.service.life_cycle_state == 'DRAFT' ? t('added_on') : t('active_since')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.added_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service && item.service.removed_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('removed_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.removed_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service && item.service.firts_activated_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('firts_activated_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.firts_activated_on)}</Typo>
                            </Grid>
                        </Grid>}
                    </Grid>
                    <Grid item xs={12} lg={5}>

                    </Grid>
                </Grid>}


                <Grid item xs={12} container justifyContent='center'>
                    <Grid item xs={12} sm={6}>
                        {from == 'subscription_page' && item.service && item.service.life_cycle_state != 'DRAFT' && <ButtonCustom size="xs" color={"primary"} onClick={() => props.onRecurringPayment(item)}>{t('recurring_payment')}</ButtonCustom>}
                    </Grid>
                    {!isFreeTV && <Grid item xs={12} sm={6} container justifyContent='flex-end'>
                        <ButtonCustom size='xs' color={'primary'} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                            Action
                        </ButtonCustom>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {showUpgradeButton && <MenuItem onClick={() => { props.onUpgradeService(item.service); handleClose(); }}>Change Service</MenuItem>}
                            {showViewDevicesButton && <MenuItem onClick={() => { props.onViewDevices(item); handleClose();}}>View Devices</MenuItem>}
                            {showCancelServiceButton && <MenuItem onClick={() => { props.onCancelService(item); handleClose(); }}>Cancel Service</MenuItem>}
                        </Menu>
                    </Grid>}
                </Grid>
            </Grid>
            {/* <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <Typo>
                        Are you sure you want to cancel this service?
                    </Typo>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleConfirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog> */}
        </Grid>
    );
}

export default withStyles(styles)(withTranslation()(SubcriptionItem));